import {Mapper} from '@s-ui/domain'

export class SeoLiteralMapper extends Mapper {
  /**
   * replace _ to blank space
   */
  _replaceToSpace = value => String(value).replace(/_/g, ' ')

  /**
   * toUppercase util
   */
  _setPlaceholderValuesToUpperCase = ({placeholderValues}) =>
    Object.keys(placeholderValues).reduce((acc, key) => {
      acc[key] = String(placeholderValues[key]).toUpperCase()
      return acc
    }, {})

  /**
   * Parse SEO data texts in order to replace all needed variables within them, removes unnecessary whitespaces.
   */
  _parseTextWithPlaceholders = () =>
    Object.keys(this._placeholderValues)
      .reduce((text, key) => {
        const placeholder = `%{${key}}`
        const replacement = this._replaceToSpace(this._placeholderValues[key] || '')
        return text.replace(new RegExp(placeholder, 'g'), replacement)
      }, this._text)
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\s\./g, '.') // Clean trailing spaces before dots
      .replace(/\s!/g, '!') // Clean trailing spaces before exclamation marks

  setText = ({text = ''}) => {
    this._text = text
    return this
  }

  setPlaceholderValues = ({placeholderValues}) => {
    this._placeholderValues = placeholderValues
    return this
  }

  setPlaceholderValuesToUpperCase = () => {
    this._placeholderValues = this._setPlaceholderValuesToUpperCase({
      placeholderValues: this._placeholderValues
    })
    return this
  }

  map = () => {
    const hasPlaceholderValues = Boolean(this._placeholderValues)
    if (hasPlaceholderValues) return this._parseTextWithPlaceholders()
    return this._text
  }
}
